import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewTools (){
  const {user} = useUser()
  let view = contentLayout[modules.ToolList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.ToolList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.ToolList}></Index>
 )
}

export default ViewTools
